// Bootstrap for the four admin pages still on legacy designer mock-JS data
// scripts (admin-requests / admin-installation-parties / admin-email-templates
// / admin-power-points). They don't have their own TS modules yet, so this
// file gates them on real Cognito auth and renders the same designer chrome
// (top bar + side nav) as every other admin page via {@link initAdminShell}.
//
// Page HTML pattern:
//   <header class="admin-bar" id="admin-bar"></header>
//   <aside class="admin-side" id="admin-side" data-active="requests" ...>
//     ...optional page-specific groups...
//   </aside>
//   <script type="module" src="/src/admin/legacy-side-init.ts"></script>
//
// When a page later gets ported to its own TS module, swap this script tag
// for a call to {@link initAdminShell} from the page module instead.

import { initAdminShell } from './shell';

const side = document.getElementById('admin-side') ?? document.querySelector<HTMLElement>('.admin-side');
const active = side?.dataset.active ?? '';

// initAdminShell handles auth-gating + envConfig + i18n + chrome + apply().
await initAdminShell(active);
